module.exports = __webpack_public_path__ + "static/media/gtl_card_icon.b1de7345.svg";